let parser = new DOMParser();
export default (html) => {
  let el = parser.parseFromString(html, 'text/html');
  return el.body.firstChild;
};
